import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { AdminStats } from "@/types";

export function useStats() {
  return useQuery({
    queryKey: ["admin-stats"],
    queryFn: () => api.get<AdminStats>("/admin/stats"),
  });
}
